import { render, staticRenderFns } from "./ClaimApprovalDetails.vue?vue&type=template&id=0fd65df9"
import script from "./ClaimApprovalDetails.vue?vue&type=script&lang=js"
export * from "./ClaimApprovalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports